export default __webpack_public_path__ + "static/data_b.b9bccb80763e05e65b8f7fb6139ef3c2.svg";